import r from "react";
import { c as y } from "./index.stoqs9MZ.js";
import { u as S, c as M } from "./index.B4ZV02se.js";
import { j as d } from "./jsx-runtime.DGlMoOmv.js";
function h(s) {
  const m = s + "CollectionProvider", [A, E] = y(m), [N, a] = A(
    m,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), p = (c) => {
    const { scope: e, children: l } = c, o = r.useRef(null), t = r.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d.jsx(N, { scope: e, itemMap: t, collectionRef: o, children: l });
  };
  p.displayName = m;
  const f = s + "CollectionSlot", _ = M(f), C = r.forwardRef(
    (c, e) => {
      const { scope: l, children: o } = c, t = a(f, l), n = S(e, t.collectionRef);
      return /* @__PURE__ */ d.jsx(_, { ref: n, children: o });
    }
  );
  C.displayName = f;
  const u = s + "CollectionItemSlot", R = "data-radix-collection-item", T = M(u), x = r.forwardRef(
    (c, e) => {
      const { scope: l, children: o, ...t } = c, n = r.useRef(null), I = S(e, n), i = a(u, l);
      return r.useEffect(() => (i.itemMap.set(n, { ref: n, ...t }), () => void i.itemMap.delete(n))), /* @__PURE__ */ d.jsx(T, { [R]: "", ref: I, children: o });
    }
  );
  x.displayName = u;
  function O(c) {
    const e = a(s + "CollectionConsumer", c);
    return r.useCallback(() => {
      const o = e.collectionRef.current;
      if (!o) return [];
      const t = Array.from(o.querySelectorAll(`[${R}]`));
      return Array.from(e.itemMap.values()).sort(
        (i, v) => t.indexOf(i.ref.current) - t.indexOf(v.ref.current)
      );
    }, [e.collectionRef, e.itemMap]);
  }
  return [
    { Provider: p, Slot: C, ItemSlot: x },
    O,
    E
  ];
}
export {
  h as c
};
//# sourceMappingURL=index.BW3XI7yS.js.map
